/* Non-critical fonts */
document.addEventListener("DOMContentLoaded",function(){var style=document.createElement("style");style.textContent=`@font-face{font-family:"Figtree";src:url("https://d2izr24fok1gc0.cloudfront.net/retail_duplicate/Figtree-Light.ttf");font-weight:300;font-style:normal;font-display:swap;}@font-face{font-family:"Figtree";src:url("https://d2izr24fok1gc0.cloudfront.net/retail_duplicate/Figtree-Regular.ttf");font-weight:400;font-style:normal;font-display:swap;}@font-face{font-family:"Figtree";src:url("https://d2izr24fok1gc0.cloudfront.net/retail_duplicate/Figtree-Medium.ttf");font-weight:500;font-style:normal;font-display:swap;}@font-face{font-family:"Figtree";src:url("https://d2izr24fok1gc0.cloudfront.net/retail_duplicate/Figtree-Bold.ttf");font-weight:700;font-style:normal;font-display:swap;}@font-face{font-family:"BigMoore";src:url("https://d2izr24fok1gc0.cloudfront.net/retail_duplicate/BigMoore-Regular.otf");font-weight:400;font-style:normal;font-display:swap;}`;document.head.appendChild(style);});
/* Start Section email_widget_v1_zive_23jan_wwai_email_widget_1_CpXW1a */
document.addEventListener('DOMContentLoaded',()=>{const timerElement=document.querySelector('.section-template--email_widget_v1_zive_23jan_wwai_email_widget_1_CpXW1a .limited_time_timer_text_class_section p');if(!timerElement)return;function getNewEndTime(){return new Date().getTime()+48*60*60*1000;}
let endTime=getNewEndTime();function updateCountdown(){const now=new Date().getTime();let remainingTime=endTime-now;if(remainingTime<=0){endTime=getNewEndTime();remainingTime=endTime-now;}
const days=Math.floor(remainingTime/(1000*60*60*24));const hours=Math.floor((remainingTime/(1000*60*60))%24);const minutes=Math.floor((remainingTime/(1000*60))%60);const seconds=Math.floor((remainingTime/1000)%60);timerElement.innerHTML=`<div><span>${days}</span><span>days</span></div><div>:</div><div><span>${hours}</span><span>hours</span></div><div>:</div><div><span>${minutes}</span><span>min</span></div><div>:</div><div><span>${seconds}</span><span>sec</span></div>`;}
setInterval(updateCountdown,1000);updateCountdown();});window.handleEmailSuccess=function(email){const mainParent=document.getElementById('main_parent');if(mainParent){mainParent.classList.add('active');window.setCookie('emailSubmitted','true',7);}else{console.error('main_parent element not found');}};document.addEventListener('DOMContentLoaded',function(){const form=document.getElementById('main_email_collect_form');const mainParent=document.getElementById('main_parent');function setCookie(name,value,days){let expires="";if(days){const date=new Date();date.setTime(date.getTime()+(days*24*60*60*1000));expires="; expires="+date.toUTCString();}
document.cookie=name+"="+(value||"")+expires+"; path=/";}
function getCookie(name){const nameEQ=name+"=";const ca=document.cookie.split(';');for(let i=0;i<ca.length;i++){let c=ca[i];while(c.charAt(0)===' ')c=c.substring(1,c.length);if(c.indexOf(nameEQ)===0)return c.substring(nameEQ.length,c.length);}
return null;}
if(getCookie('emailSubmitted')==='true'){mainParent.classList.add('active');}
window.setCookie=setCookie;});
/* End Section email_widget_v1_zive_23jan_wwai_email_widget_1_CpXW1a */

document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();

            document.querySelector(this.getAttribute('href')).scrollIntoView({
                behavior: 'smooth'
            });
        });
    });
});

/*
class VideoPlayer extends HTMLElement {
  constructor() {
    super();
    this.videos = this.querySelectorAll('video');
    this.videoWeb = this.videos[0];
    this.videoMob = this.videos[1];
    this.playBtn = this.querySelector('.play-btn');
    this.soundBtn = this.querySelector('.mute-btn');
    this.disableClick = this.dataset.click;
    if (this.disableClick) {
      this.initEventListeners();
    }
  }

  initEventListeners() {
    this.videos.forEach(video => {
      video.addEventListener('click', () => this.togglePlay(video));
      video.addEventListener('ended', () => this.handleVideoEnded(video)); // Listen for the `ended` event
    });

    if (this.playBtn) {
      this.playBtn.addEventListener('click', () => this.handlePlayButton());
    }

    if (this.soundBtn) {
      this.soundBtn.addEventListener('click', () => this.toggleMute());
    }

    window.addEventListener('resize', () => this.handleResize());
  }

  togglePlay(video) {
    if (video.paused) {
      this.playVideo(video);
    } else {
      this.pauseVideo(video);
    }
  }

  playVideo(video) {
    this.videos.forEach(otherVideo => {
      if (otherVideo !== video) otherVideo.pause();
    });
    video.play();
    this.classList.add('played');
  }

  pauseVideo(video) {
    video.pause();
    this.classList.remove('played');
  }

  handlePlayButton() {
    const targetVideo = window.innerWidth < 749 && this.videoMob ? this.videoMob : this.videoWeb;
    if (targetVideo) this.togglePlay(targetVideo);
  }

  toggleMute() {
    const targetVideo = window.innerWidth < 749 && this.videoMob ? this.videoMob : this.videoWeb;
    if (targetVideo) {
      targetVideo.muted = !targetVideo.muted;
      this.soundBtn.classList.toggle('active', targetVideo.muted);
    }
  }

  handleResize() {
    if (!this.videoMob) return;

    const isMobile = window.innerWidth < 749;
    const targetVideo = isMobile ? this.videoMob : this.videoWeb;

    this.videos.forEach(video => video.pause());
    targetVideo.play();
    targetVideo.pause(); // Ensure the video is ready for user interaction
  }

  handleVideoEnded(video) {
    // Check if the video is not set to loop
    if (!video.loop) {
      this.classList.remove('played');
    }
  }
}

customElements.define('video-player', VideoPlayer);
*/
(function () {
  // Check if the custom element is already defined
  if (!customElements.get('video-player')) {
    class VideoPlayer extends HTMLElement {
      constructor() {
        super();
        this.videos = this.querySelectorAll('video');
        this.videoWeb = this.videos[0];
        this.videoMob = this.videos[1];
        this.playBtn = this.querySelector('.play-btn');
        this.soundBtn = this.querySelector('.mute-btn');
        this.disableClick = this.dataset.click;

        if (this.disableClick) {
          this.initEventListeners();
        }
      }

      initEventListeners() {
        this.videos.forEach(video => {
          video.addEventListener('click', () => this.togglePlay(video));
          video.addEventListener('ended', () => this.handleVideoEnded(video)); // Listen for the `ended` event
        });

        if (this.playBtn) {
          this.playBtn.addEventListener('click', () => this.handlePlayButton());
        }

        if (this.soundBtn) {
          this.soundBtn.addEventListener('click', () => this.toggleMute());
        }

        window.addEventListener('resize', () => this.handleResize());
      }

      togglePlay(video) {
        if (video.paused) {
          this.playVideo(video);
        } else {
          this.pauseVideo(video);
        }
      }

      playVideo(video) {
        this.videos.forEach(otherVideo => {
          if (otherVideo !== video) otherVideo.pause();
        });
        video.play();
        this.classList.add('played');
      }

      pauseVideo(video) {
        video.pause();
        this.classList.remove('played');
      }

      handlePlayButton() {
        const targetVideo = window.innerWidth < 749 && this.videoMob ? this.videoMob : this.videoWeb;
        if (targetVideo) this.togglePlay(targetVideo);
      }

      toggleMute() {
        const targetVideo = window.innerWidth < 749 && this.videoMob ? this.videoMob : this.videoWeb;
        if (targetVideo) {
          targetVideo.muted = !targetVideo.muted;
          this.soundBtn.classList.toggle('active', targetVideo.muted);
        }
      }

      handleResize() {
        if (!this.videoMob) return;

        const isMobile = window.innerWidth < 749;
        const targetVideo = isMobile ? this.videoMob : this.videoWeb;

        this.videos.forEach(video => video.pause());
        targetVideo.play();
        targetVideo.pause(); // Ensure the video is ready for user interaction
      }

      handleVideoEnded(video) {
        // Check if the video is not set to loop
        if (!video.loop) {
          this.classList.remove('played');
        }
      }
    }

    // Define the custom element
    customElements.define('video-player', VideoPlayer);
  }
})();
class WordsworthAiEmailCaptureHandler extends HTMLElement {
    constructor() {
        super();
        this.formType = this.getAttribute('form_type');
        this.successCallback = window[this.getAttribute('onEmailHandleSuccess')];
        this.isDebugMode = this.getAttribute('debug_mode') === "true"; // Convert to boolean
    }

    connectedCallback() {
        const form = this.querySelector('form');
        if (!form) return;
        
        // Remove any existing submit listeners
        const newForm = form.cloneNode(true);
        form.parentNode.replaceChild(newForm, form);
        
        newForm.addEventListener('submit', (e) => this.handleSubmit(e));
    }

    async handleSubmit(e) {
        e.preventDefault();
        
        const form = e.target;
        const emailInput = form.querySelector('[name="email"], #inputemail, .inputemail, input[type="email"]');
        if (!emailInput) {
            console.error('Email input not found');
            return;
        }

        const email = emailInput.value.trim();
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!email || !emailRegex.test(email)) {
            alert('Please enter a valid email address.');
            emailInput.focus();
            return;
        }

        const submitButton = form.querySelector('button[type="submit"], input[type="submit"]');
        if (submitButton) submitButton.disabled = true;

        try {
            const discountInput = form.querySelector('#discountCode') || form.querySelector('[name="discountCode"]');
            const discountCode = discountInput ? discountInput.value : null;

            const eventData = {
                form_type: this.formType,
                form_id: form.id || 'unknown',
                email,
                discount_code: discountCode,
                email_provided: true,
                is_valid_email: true,
                path: window.location.pathname,
                timestamp: new Date().toISOString(),
                section_id: this.closest('[id^="shopify-section"]')?.id || null,
                form_location: {
                    href: window.location.href,
                    pathname: window.location.pathname
                }
            };

            // Check debug mode or attempt event publishing
            const canProceed = this.isDebugMode || 
                              (window.wwaiEventPublisher && typeof window.wwaiEventPublisher.publish === "function");
            
            if (this.isDebugMode) {
                console.log("Debug Mode: Event Data", JSON.stringify(eventData, null, 2));
            } else if (canProceed) {
                console.log("Sending captured email to backend.");
                window.wwaiEventPublisher.publish('wwai_form_submission', eventData);
            } else {
                console.warn("wwaiEventPublisher is not available.");
            }
            
            // Handle success or failure
            if (canProceed) {
                if (typeof this.successCallback === 'function') {
                    this.successCallback(eventData); // Pass full data
                }
                emailInput.value = '';
            } else {
                alert("Error while capturing emails. Please try again later or contact support.");
            }

        } catch (error) {
            console.error('Error submitting form:', error);
        } finally {
            if (submitButton) submitButton.disabled = false;
        }
    }
}

customElements.define('wordsworthai-email-capture', WordsworthAiEmailCaptureHandler);